import { useContext, useEffect } from 'react';
import LoginFlow from '../LoginFlow';
import { useNavigate } from 'react-router-dom';
import Loader from '../../loading/Loader';
import { UserContext } from '@context/createContext';

export default function Login() {
  // const navigate = useNavigate();

  const { user, isLoading } = useContext(UserContext);

  // useEffect(() => {
  //   if (user && user.realState) {
  //     navigate(`/${user.UserType}/dashboard`, { replace: true });
  //   } else if (user && !user.realState) {
  //     navigate(`/${user.UserType}/requests`, { replace: true });
  //   }
  // }, [user, navigate]);

  if (isLoading)
    return (
      <div className="flex items-center justify-center h-screen w-full">
        <Loader />
      </div>
    );

  if (!user)
    return (
      <section dir="rtl" className="w-screen min-h-screen lg:h-dvh overflow-hidden bg-white dark:bg-blackFont-900">
        <div className="w-full h-full flex items-center justify-between p-4 md:p-5 2xl:p-16 gap-8">
          <div className="w-full md:w-8/12 h-full flex flex-col justify-between gap-4 overflow-y-auto scrollNone">
            <div className="w-full flex items-center justify-start">
              <a
                href="https://dubz.ir"
                className={`flex items-center justify-start gap-2 p-3 rounded-3xl w-fit group text-xs md:text-base text-blackFont-700 dark:text-blackFont-300`}
              >
                <img
                  className="w-5 lg:w-6 group-hover:translate-x-2 transition-all rotate-180"
                  src="/svg/arrow-left-a.svg"
                  alt="arrow-left"
                />
                <span>بازگشت به صفحه اصلی دابز</span>
              </a>
            </div>
            <LoginFlow />
            <div className="w-full hidden md:flex items-center justify-between text-blackFont-600 dark:text-blackFont-400 gap-4">
              {/* <span className="text-[10px] lg:text-sm">
                تمامی حقوق مادی و معنوی این سایت متعلق به دابز است
              </span>
              <span className="flex items-center gap-2">
                <span className="text-xs lg:text-base whitespace-nowrap">
                  09120303565
                </span>
                <svg
                  className="w-4 h-4 lg:w-6 lg:h-6"
                  viewBox="0 0 22 22"
                  fill="none"
                  stroke="currentColor"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M20.1388 16.8024C20.1388 17.1324 20.0655 17.4716 19.9097 17.8016C19.7538 18.1316 19.5522 18.4433 19.2863 18.7366C18.8372 19.2316 18.3422 19.5891 17.783 19.8183C17.233 20.0474 16.6372 20.1666 15.9955 20.1666C15.0605 20.1666 14.0613 19.9466 13.0072 19.4974C11.953 19.0483 10.8988 18.4433 9.85384 17.6824C8.79967 16.9124 7.80051 16.0599 6.84717 15.1158C5.90301 14.1624 5.05051 13.1633 4.28967 12.1183C3.53801 11.0733 2.93301 10.0283 2.49301 8.99242C2.05301 7.94742 1.83301 6.94825 1.83301 5.99492C1.83301 5.37159 1.94301 4.77575 2.16301 4.22575C2.38301 3.66659 2.73134 3.15325 3.21717 2.69492C3.80384 2.11742 4.44551 1.83325 5.12384 1.83325C5.38051 1.83325 5.63717 1.88825 5.86634 1.99825C6.10467 2.10825 6.31551 2.27325 6.48051 2.51159L8.60717 5.50909C8.77217 5.73825 8.89134 5.94909 8.97384 6.15075C9.05634 6.34325 9.10217 6.53575 9.10217 6.70992C9.10217 6.92992 9.03801 7.14992 8.90967 7.36075C8.79051 7.57158 8.61634 7.79158 8.39634 8.01158L7.69967 8.73575C7.59884 8.83658 7.55301 8.95575 7.55301 9.10242C7.55301 9.17575 7.56217 9.23992 7.58051 9.31325C7.60801 9.38658 7.63551 9.44158 7.65384 9.49658C7.81884 9.79908 8.10301 10.1933 8.50634 10.6699C8.91884 11.1466 9.35884 11.6324 9.83551 12.1183C10.3305 12.6041 10.8072 13.0533 11.293 13.4658C11.7697 13.8691 12.1638 14.1441 12.4755 14.3091C12.5213 14.3274 12.5763 14.3549 12.6405 14.3824C12.7138 14.4099 12.7872 14.4191 12.8697 14.4191C13.0255 14.4191 13.1447 14.3641 13.2455 14.2633L13.9422 13.5758C14.1713 13.3466 14.3913 13.1724 14.6022 13.0624C14.813 12.9341 15.0238 12.8699 15.253 12.8699C15.4272 12.8699 15.6105 12.9066 15.8122 12.9891C16.0138 13.0716 16.2247 13.1908 16.4538 13.3466L19.488 15.5008C19.7263 15.6658 19.8913 15.8583 19.9922 16.0874C20.0838 16.3166 20.1388 16.5458 20.1388 16.8024Z"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeMiterlimit="10"
                  />
                  <path
                    d="M16.9583 8.24984C16.9583 7.69984 16.5275 6.8565 15.8858 6.169C15.2992 5.5365 14.52 5.0415 13.75 5.0415"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M20.1667 8.24992C20.1667 4.70242 17.2975 1.83325 13.75 1.83325"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </span> */}
            </div>
          </div>
          <div className="w-4/12 md:h-full hidden md:block rounded-2xl overflow-hidden">
            <img
              className="w-full h-full object-cover overflow-hidden rounded-2xl"
              src="/images/loginPanelpic.webp"
              alt="loginPanelpic"
            />
          </div>
        </div>
      </section>
    );
}
